import { Link } from 'react-router-dom';
import s from './Breadcrumb.module.scss';

const Breadcrumb = ({ pathData, className = '', overlay = false }) => {
  return (
    <nav
      className={`
        ${s.root}
        ${overlay ? s.overlay : s.normal}
        ${className}
      `}
      aria-label="Breadcrumb"
    >
      <ul className={s.breadcrumb}>
        {pathData.map((item, index) => {
          const isLast = index === pathData.length - 1;

          return (
            <li key={`${item.path}-${item.title}`} className={s.item}>
              {isLast ? (
                <span className={s.current} aria-current="page">
                  {item.title}
                </span>
              ) : (
                <Link to={item.path} className={s.link}>
                  {item.title}
                </Link>
              )}
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default Breadcrumb;
